import { httpClient } from 'common/services';
import type { CreateCommentRequest } from 'features/call/call-survey/interfaces';

async function createComment(body: CreateCommentRequest) {
  const route = '/comments';
  const response = await httpClient.post(route, body);
  return response.data;
}

export const CommentDaoService = {
  createComment,
};
